<script lang="ts" setup>
import type { AppButtonSize } from 'libs/ui/src/lib/components/appButton/AppButton.model';

import type { AppButtonType } from '@libs/ui';
import { AppButton } from '@libs/ui';

import type { HomeFlightData } from './AirportSelector.model';

interface HomeAirportSelectorButtonProps {
  homeFlightData: HomeFlightData;
  spaceBetween?: boolean;
  type?: AppButtonType;
  size?: AppButtonSize;
}
const props = withDefaults(defineProps<HomeAirportSelectorButtonProps>(), {
  size: 'small',
  type: 'modern',
});
</script>

<template>
  <AppButton
    :type="props.type"
    state="enabled"
    :size="props.size"
    :left-icon="{
      size: '18',
      name: 'airplaneTakeoff',
    }"
    :right-icon="{
      size: '18',
      name: 'chevronDown',
    }"
    :space-between="props.spaceBetween"
  >
    {{ props.homeFlightData.airport.name }}
  </AppButton>
</template>
